import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import classnames from 'classnames/bind';
import ReCAPTCHA from 'react-google-recaptcha';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import {
    ERRORS,
    NEW_FORGOT_PASSWORD,
    SIGN_IN,
} from 'yoda-checkout-components/lib/common/LabelConstants';
import {
    ANALYTICS_ACTIONS_LOGIN_ATTEMPTED,
    CAPTCHA_ENABLED_SIGNIN,
    PAGE_TITLES_SIGN_IN,
    RECAPTCHA_ERRORCODES_INVALID,
    RECAPTCHA_SITE_KEY,
    URL_RESET_PASSWORD_PAGE,
    RECAPTCHA_ERRORCODES_LAST_ATTEMPT,
    RECAPTCHA_ERRORCODES_NOT_FOUND,
} from 'yoda-checkout-components/lib/common/Constants';
import withBoundaryError from 'yoda-checkout-components/lib/components/ErrorBoundary/ErrorBoundaryHOC';
import SessionTimeoutModal from 'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal';
import * as analyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import splunkLogsActions from 'yoda-checkout-components/lib/actions/SplunkLogsActions';
import siteAnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import Button from 'yoda-core-components/lib/components/Button';
import InputField from 'yoda-checkout-components/lib/components/CustomTags/InputField/InputField';
import MessageField from 'yoda-checkout-components/lib/components/CustomTags/MessageField/MessageField';
import EmailAutoSuggestInputField from 'yoda-checkout-components/lib/components/CustomTags/EmailAutoSuggestInputField/EmailAutoSuggestInputField';
import * as SigninAction from 'yoda-checkout-components/lib/actions/SigninAction';
import {
    isGiftCardOrderOnly,
    setGlobalErrorHandler,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { scrollToElement } from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import validate from 'yoda-account-components/lib/helpers/Validators/EmailValidator';
import LiveChat from 'yoda-checkout-components/lib/components/LiveChat/LiveChat';
import ServiceErrorMessage from 'yoda-checkout-components/lib/components/ServiceErrorMessage/ServiceErrorMessage';
import CheckoutHeader from 'yoda-checkout-components/lib/components/CheckoutHeader/CheckoutHeader';
import Footer from 'yoda-checkout-components/lib/components/Footer/Footer';
import KeepMeSignedIn from 'yoda-checkout-components/lib/components/KeepMeSignedIn/KeepMeSignedIn';
import DelaySpinner from 'yoda-checkout-components/lib/components/DelaySpinner/DelaySpinner';
import OOSModal from 'yoda-checkout-components/lib/components/OOSModal/OOSModalLazy';
import { CART_PAGE_URL } from 'yoda-site-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import * as ServiceErrorMessageAction from 'yoda-checkout-components/lib/actions/ServiceErrorHandlerAction';
import FreeShippingThresholdLazy from 'yoda-checkout-components/lib/components/FreeShippingThreshold/FreeShippingThresholdLazy';
import PromotionalBannerActions from 'yoda-site-components/lib/actions/PromotionalBannerAction';
import getLocationPath from 'yoda-site-components/lib/utils';
import { getCartDetails } from '../../../actions/GetCartDetailsAction';
import CreateAccountButton from './components/CreateAccountButton/CreateAccountButton';
import ContinueAsGuest from './components/ContinueAsGuest/ContinueAsGuest';
import * as styles from './SignInPage.css';

const cx = classnames.bind(styles);
let isPageLoadSuccessActionFired = false;
const section = 'SIGN_IN';
let isSiteWidePromoCalled = false;

export class SignInPage extends Component {
    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        cartDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
        orderItems: PropTypes.arrayOf(PropTypes.object).isRequired,
        analyticsClickEvent: PropTypes.string.isRequired,
        showGlobalLoader: PropTypes.bool,
        deviceType: PropTypes.objectOf(PropTypes.object),
        serviceErrors: PropTypes.objectOf(PropTypes.object),
        context: PropTypes.objectOf(PropTypes.object).isRequired,
        isSessionTimedOut: PropTypes.bool,
        featureFlags: PropTypes.objectOf(PropTypes.object),
        enableKeepMeLoggedIn: PropTypes.bool,
        oosDetails: PropTypes.oneOfType(PropTypes.object),
        irisRewardCustomerThreshold: PropTypes.string,
    };

    static defaultProps = {
        enableKeepMeLoggedIn: false,
        showGlobalLoader: false,
        actions: {},
        deviceType: {},
        serviceErrors: null,
        isSessionTimedOut: false,
        featureFlags: {},
        oosDetails: {},
        irisRewardCustomerThreshold: '',
    };

    constructor() {
        super();
        this.doSignIn = this.doSignIn.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onEmailBlur = this.onEmailBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.captchaChange = this.captchaChange.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
        this.togglekeepMeSignedIn = this.togglekeepMeSignedIn.bind(this);
        this.continueToCart = this.continueToCart.bind(this);
        this.getSitePromoData = this.getSitePromoData.bind(this);
        this.errorSubscription = () => {};
        this.state = {
            email: '',
            password: '',
            captchError: '',
            isInlineError: false,
            isInlineEmailError: false,
            captchaToken: '',
            showCaptcha: false,
            contextList: ['CART'],
            passwordType: 'password',
            keepMeSignedIn: false,
        };
        this.email = React.createRef();
        this.password = React.createRef();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (!__SERVER__) {
            window.jcpDLjcp = {};
            scrollToElement();
        }
        // DA => Page load and click event handler for SignIn Page
        if (get(this.props.cartDetails, 'data') && !isPageLoadSuccessActionFired) {
            isPageLoadSuccessActionFired = true;
            this.props.actions.pageLoadSuccessAnalyticsAction('checkout login');
        } else {
            this.props.actions.getCartDetails();
        }
        if (!isEmpty(this.props.analyticsClickEvent)) {
            this.props.actions.clickEventAnalyticsAction(this.props.analyticsClickEvent);
            // Flush previously stored analytics action from store
            this.props.actions.updateAnalyticsClickAction({});
        }
    }

    componentDidMount() {
        const enableGlobalErrorLogs = get(
            this.props.featureFlags,
            'splunkLogs.enableGlobalErrorLogs'
        );
        const enableFSHBanner = get(this.props.featureFlags, 'enableFSHBanner');
        const userState = TokenProvider.get('DP_USER_STATE');
        const isLoggedIn = userState === '1' || userState === 1;
        if (isLoggedIn) {
            getBrowserHistory().push('/cart');
        }
        /* istanbul ignore next */
        if (enableGlobalErrorLogs) {
            this.errorSubscription = setGlobalErrorHandler(
                section,
                this.props.actions.logGlobalError
            );
        }
        if (
            !__SERVER__ &&
            enableFSHBanner &&
            !isSiteWidePromoCalled &&
            !this.props.irisPromotionalBannerDataContent
        ) {
            this.getSitePromoData();
            isSiteWidePromoCalled = true;
        }
    }

    getSitePromoData() {
        /* istanbul ignore next */
        const seoUrl = getLocationPath(window.location.pathname);
        const {
            deviceType,
            featureFlags: {
                disableIrisCall = false,
                disableSitewideSeoUrlforPromo = false,
                enableIrisSitePromo = false,
            },
        } = this.props;
        const locationParams = seoUrl + window.location.search;
        const getUrl = disableSitewideSeoUrlforPromo ? '' : locationParams;
        /* istanbul ignore else */
        if (!disableIrisCall) {
            enableIrisSitePromo
                ? this.props.actions.getIrisOfferDetailsAction(getUrl)
                : this.props.actions.getOfferDetailsAction(deviceType);
        }
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillReceiveProps(nextProps) {
        /* istanbul ignore else */
        if (
            !isEmpty(nextProps.serviceErrors.errors) &&
            this.props.serviceErrors !== nextProps.serviceErrors
        ) {
            const { errors } = nextProps.serviceErrors;
            /* istanbul ignore else */
            if (!isEmpty(errors.code)) {
                const errorCode = errors.code;
                if (errorCode === RECAPTCHA_ERRORCODES_LAST_ATTEMPT) {
                    this.setState({ showCaptcha: true });
                } else if (
                    errorCode === RECAPTCHA_ERRORCODES_NOT_FOUND ||
                    errorCode === RECAPTCHA_ERRORCODES_INVALID
                ) {
                    this.captcha && this.captcha.reset();
                    this.captchaChange(null);
                    this.setState({ showCaptcha: true });
                }
            }
        }
        /* istanbul ignore else */
        if (
            !isEmpty(nextProps.cartDetails.data) &&
            !isEqual(this.props.cartDetails, nextProps.cartDetails)
        ) {
            isPageLoadSuccessActionFired = true;
            this.props.actions.pageLoadSuccessAnalyticsAction('checkout login');
        }
    }

    componentWillUnmount() {
        this.errorSubscription();
    }

    handleFocus(event) {
        this.props.actions.clearServiceErrorMessage();
        /* istanbul ignore next */
        if (event === '') {
            if (this.state.isInlineEmailError) {
                this.setState({ isInlineEmailError: true, isInlineError: false });
            }
        } else {
            this.setState({ isInlineEmailError: false, isInlineError: false });
        }
        /* istanbul ignore else */
        if (
            this.password &&
            this.password.current &&
            this.password.current.matches(':-webkit-autofill')
        ) {
            if (document?.querySelector('#cartSignInPassword')?.value) {
                document.querySelector('#cartSignInPassword').value = `${
                    document.querySelector('#cartSignInPassword').value
                } `;
                document.querySelector('#cartSignInPassword').value = document
                    .querySelector('#cartSignInPassword')
                    .value?.trim();
            }
        }
        if (this.email && this.email.current && this.email.current.matches(':-webkit-autofill')) {
            if (document?.querySelector('#email')?.value) {
                document.querySelector('#email').value = `${
                    document.querySelector('#email').value
                } `;
                document.querySelector('#email').value = document
                    .querySelector('#email')
                    .value?.trim();
            }
        }
    }

    onEmailChange(value) {
        this.setState({
            email: value,
        });
    }

    /* istanbul ignore next */
    onEmailBlur = (e) => {
        const emailValue = e?.target?.value || '';
        const signInEmail = {};
        signInEmail.email = emailValue;
        this.setState({ isInlineEmailError: false });
        if (!isEmpty(emailValue) && !isEmpty(validate(signInEmail))) {
            this.setState({ isInlineEmailError: true });
        }
    };

    onPasswordChange(value) {
        this.setState({
            password: value,
        });
    }

    captchaChange(response) {
        this.setState({ captchaToken: response, captchError: '' });
    }

    togglekeepMeSignedIn() {
        this.setState({
            keepMeSignedIn: !this.state.keepMeSignedIn,
        });
    }

    doSignIn() {
        const payload = {
            email: this.state.email,
            password: this.state.password,
            keepMeSignedIn: this.state.keepMeSignedIn,
        };
        this.state.showCaptcha && (payload.captchaToken = this.state.captchaToken);
        // DA ===> trigger an adobe event for a sign in attempt.
        this.props.actions.clickEventAnalyticsAction(ANALYTICS_ACTIONS_LOGIN_ATTEMPTED);
        /* istanbul ignore else */
        let errorDisplay = false;
        let formErrorContent =
            (!this.state.email && [{ errorDescription: ERRORS.EMPTY_EMAIL_ONLY }]) ||
            (!this.state.password && [{ errorDescription: ERRORS.EMPTY_VALID_PASSWORD }]);
        this.setState({ isInlineEmailError: false });
        if (!payload.email) {
            this.setState({
                isInlineEmailError: true,
            });
            /* istanbul ignore else */
            if (!this.state.email) {
                formErrorContent = [{ errorDescription: ERRORS.EMPTY_EMAIL_ONLY }];
            }
            errorDisplay = true;
        } else {
            const signInEmail = {};
            signInEmail.email = payload.email;
            this.setState({ isInlineEmailError: false });
            if (!isEmpty(payload.email) && !isEmpty(validate(signInEmail))) {
                this.setState({ isInlineEmailError: true });
                errorDisplay = true;
            }
        }
        if (!payload.password) {
            this.setState({
                isInlineError: true,
            });
            /* istanbul ignore else */
            if (!this.state.password) {
                formErrorContent = [{ errorDescription: ERRORS.EMPTY_VALID_PASSWORD }];
            }
            errorDisplay = true;
        }
        if (errorDisplay) {
            this.props.actions.triggerFormError(formErrorContent);
            return;
        }
        /* istanbul ignore else */
        if (this.state.showCaptcha && !payload.captchaToken) {
            this.setState({
                captchError: 'Please enter a valid captcha',
            });
            return;
        }
        this.props.actions.postSignIn(payload);
    }

    resetPassword() {
        getBrowserHistory().push(URL_RESET_PASSWORD_PAGE);
    }

    showHidePassword(e) {
        e.preventDefault();
        e.stopPropagation();
        if (document?.querySelector('#cartSignInPassword')?.value) {
            document.querySelector('#cartSignInPassword').value = document
                .querySelector('#cartSignInPassword')
                .value.trim();
        }
        this.setState({
            passwordType: this.state.passwordType === 'password' ? 'text' : 'password',
        });
    }

    continueToCart() {
        window.location.href = CART_PAGE_URL;
    }

    truckableItemsInCart() {
        const { orderItems } = this.props;
        /** assume truckable while waiting for order-api response
         * this prevents FSH banner from flashing for truckable items
         */
        if (!orderItems?.length) return true;
        const isTruckableItem = orderItems?.some?.(
            (item) => item.product?.truckable && item.product?.type !== 'LARGEAPPLIANCE'
        );
        return isTruckableItem;
    }

    render() {
        const {
            showGlobalLoader,
            featureFlags: { enableEmailAutosuggestion = true, enableFSHBanner = false },
            irisRewardCustomerThreshold,
            orderItems,
        } = this.props;
        const activeLoaderClass = showGlobalLoader ? 'progressActive' : '';
        const emailLabel = 'Email';
        let emailAutoFocus = false;
        let passwdAutoFocus = false;
        if (this.props.deviceType.isDesktop) {
            emailAutoFocus = isEmpty(this.state.email);
            passwdAutoFocus = !emailAutoFocus;
        }
        const preferences = get(this.props.context, 'preferences', {});
        if (!__SERVER__ && this.props.deviceType.isMobile) {
            document.body.style.position = '';
        }
        const showFreeShippingThreshold =
            enableFSHBanner &&
            irisRewardCustomerThreshold &&
            !this.truckableItemsInCart() &&
            !isGiftCardOrderOnly(orderItems);

        return (
            <section
                className={`${cx('signInMainWrapper', 'tailwindGrid')} ${dt([
                    'overflow-hidden',
                    'relative',
                ])}`}
            >
                <CheckoutHeader
                    items={
                        this.props.cartDetails.data ? this.props.cartDetails.data.bag.itemCount : 0
                    }
                    deviceType={this.props.deviceType}
                    feedbackToken={preferences.feedbackToken}
                />
                <SessionTimeoutModal isShowModal={this.props.isSessionTimedOut} />
                <Helmet title={PAGE_TITLES_SIGN_IN} />
                <section
                    className={`${cx('signInBlock')} ${dt([
                        'bg-white',
                        'mt-0',
                        'mx-auto',
                        'pt-0',
                        'sm:max-w-[1440px]',
                        'sm:!px-6',
                        'lg:min-h-[calc(100vh-192px)]',
                        'mdOnly:min-h-[calc(100vh-232px)]',
                        'smOnly:min-h-[calc(100vh-296px)]',
                        'font-open-sans',
                        !this.props.deviceType.isDesktop && 'cursor-pointer',
                    ])}`}
                >
                    <article className={cx(activeLoaderClass)}>
                        {activeLoaderClass && <DelaySpinner />}
                        <ServiceErrorMessage
                            contextList={this.state.contextList}
                            componentName="CART_SECTION"
                        />
                        <div className={`${cx('signInWrapper')} ${dt(['text-center'])}`}>
                            <div className={`${cx('errorMsgWrapper')} ${dt(['w-full'])}`} />
                            <div
                                className={` ${dt([
                                    'flex',
                                    'flex-row',
                                    'justify-center',
                                    'mb-10',
                                    'smOnly:flex-col',
                                    'lg4',
                                    'sm12',
                                    'md6',
                                    '!p-0',
                                ])}`}
                            >
                                <form className={cx('signInForm')}>
                                    <div className={dt(['w-full'])}>
                                        <ContinueAsGuest
                                            showGlobalLoader={this.props.showGlobalLoader}
                                        />
                                        <div className={` ${dt(['text-center'])}`}>
                                            <div
                                                className={` ${dt([
                                                    'border-t',
                                                    'border-b-0',
                                                    'border-l-0',
                                                    'border-r-0',
                                                    'border-solid',
                                                    'border-gray-15',
                                                    'my-0',
                                                    'mx-auto',
                                                    'mb-4',
                                                ])}`}
                                            >
                                                <p
                                                    className={` ${dt([
                                                        '-mt-3.5',
                                                        'mx-auto',
                                                        'bg-white',
                                                        'text-center',
                                                        'w-8',
                                                        'text-black',
                                                        'text-base',
                                                        'font-open-sans-semibold',
                                                    ])}`}
                                                >
                                                    or
                                                </p>
                                            </div>
                                        </div>
                                        {showFreeShippingThreshold && (
                                            <FreeShippingThresholdLazy renderFrom="cartSignIn" />
                                        )}
                                    </div>
                                    <div className={` ${dt(['w-full'])}`}>
                                        <ServiceErrorMessage
                                            componentName="SIGNIN_SECTION"
                                            srvErrorWrapperClass={['!mx-0']}
                                            fromCartSignInPage
                                        />
                                    </div>
                                    {enableEmailAutosuggestion ? (
                                        <EmailAutoSuggestInputField
                                            name="email"
                                            id="email"
                                            type="email"
                                            placeholder={emailLabel}
                                            autoFocus={emailAutoFocus}
                                            onFocus={this.handleFocus}
                                            onChange={this.onEmailChange}
                                            hasError={this.state.isInlineEmailError}
                                            errorMsg={ERRORS.EMPTY_EMAIL_ONLY}
                                            errorAutomationId="at-signin-email-error"
                                            ariaRequired
                                            required
                                            value={this.state.email}
                                            refCallBack={this.email}
                                        />
                                    ) : (
                                        <InputField
                                            type="email"
                                            name="email"
                                            id="emailAddress"
                                            automationId="at-email-field"
                                            placeholder={emailLabel}
                                            value={this.state.email}
                                            autoFocus={emailAutoFocus}
                                            maxLength={70}
                                            hasError={this.state.isInlineEmailError}
                                            errorMsg={ERRORS.EMPTY_EMAIL_ONLY}
                                            errorAutomationId="at-signin-email-error"
                                            onChange={this.onEmailChange}
                                            onBlur={this.onEmailBlur}
                                            ariaRequired
                                            required
                                            refCallBack={this.email}
                                            dataQmBlock
                                        />
                                    )}
                                    <div className={` ${dt(['w-full', 'relative'])}`}>
                                        <InputField
                                            type={this.state.passwordType}
                                            name="password"
                                            id="cartSignInPassword"
                                            automationId="at-password-field"
                                            placeholder="Password"
                                            value={this.state.password}
                                            theme={` ${dt(['!pr-12'])}`}
                                            onFocus={this.handleFocus}
                                            autoFocus={passwdAutoFocus}
                                            hasError={
                                                this.state.isInlineError && !this.state.password
                                            }
                                            errorMsg={ERRORS.EMPTY_VALID_PASSWORD}
                                            errorAutomationId="at-signin-password-error"
                                            onChange={this.onPasswordChange}
                                            ariaRequired
                                            required
                                            refCallBack={this.password}
                                            dataQmBlock
                                        />
                                        <Button
                                            automationId="show-hide-password"
                                            tabIndex="-1"
                                            buttonType="Link"
                                            type="button"
                                            className={`${cx(
                                                'showHidePassword',
                                                'newShowHidePassword'
                                            )} ${dt([
                                                'absolute',
                                                'top-2.5',
                                                'right-2.5',
                                                '!underline',
                                                '!text-xsmall',
                                                '!text-gray-70',
                                            ])}`}
                                            onClick={this.showHidePassword}
                                        >
                                            <span
                                                className={dt([
                                                    '!p-1.5',
                                                    '!underline',
                                                    '!text-xsmall',
                                                    '!text-gray-70',
                                                ])}
                                            >
                                                {this.state.passwordType === 'password' ? (
                                                    <span>show</span>
                                                ) : (
                                                    <span>hide</span>
                                                )}
                                            </span>
                                        </Button>
                                    </div>
                                    {this.props.enableKeepMeLoggedIn && (
                                        <KeepMeSignedIn
                                            onChange={this.togglekeepMeSignedIn}
                                            handleForgotPassword={this.resetPassword}
                                        />
                                    )}
                                    <Button
                                        automationId="at-sign-in-button"
                                        buttonType="Primary"
                                        size="Lg"
                                        type="button"
                                        className={dt([
                                            'w-full',
                                            'mt-6',
                                            'mx-auto',
                                            'lg:max-w-[300px]',
                                        ])}
                                        onClick={this.doSignIn}
                                        isDisabled={this.props.showGlobalLoader}
                                    >
                                        {SIGN_IN}
                                    </Button>
                                    {
                                        /* istanbul ignore next */
                                        this.state.showCaptcha && CAPTCHA_ENABLED_SIGNIN && (
                                            <>
                                                <div
                                                    className={` ${dt([
                                                        'flex',
                                                        'justify-center',
                                                        'mt-6',
                                                    ])}`}
                                                >
                                                    <ReCAPTCHA
                                                        sitekey={RECAPTCHA_SITE_KEY}
                                                        onChange={this.captchaChange}
                                                        ref={(el) => {
                                                            this.captcha = el;
                                                        }}
                                                    />
                                                </div>
                                                {this.state.captchError && (
                                                    <MessageField
                                                        type="error"
                                                        level="inline"
                                                        content={this.state.captchError}
                                                        automationId="at-captcha-error"
                                                    />
                                                )}
                                            </>
                                        )
                                    }
                                    <Button
                                        automationId="at-forgot-password-link"
                                        buttonType="Text"
                                        size="Md"
                                        onClick={this.resetPassword}
                                        className={` ${dt(['mt-4', '!w-auto', '!mx-auto'])}`}
                                    >
                                        {NEW_FORGOT_PASSWORD}
                                    </Button>
                                    {/* </div>
                                    </div> */}
                                    <div className={dt(['mt-4', 'w-full'])}>
                                        <CreateAccountButton
                                            checkoutSessionInit={
                                                this.props.actions.checkoutSessionInit
                                            }
                                            showGlobalLoader={this.props.showGlobalLoader}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </article>
                    {this.props.oosDetails && this.props.oosDetails.showGenericOOSModal && (
                        <OOSModal
                            onClose={this.continueToCart}
                            onCheckout={this.continueToCart}
                            onContinue={this.continueToCart}
                            defaultCloseBtn={this.continueToCart}
                            showGenericModal
                            isShowModal
                        />
                    )}
                    <LiveChat />
                </section>
                <Footer
                    isDesktop={this.props.deviceType.isDesktop}
                    phoneNumber={preferences.jcpHelpPhoneNumber}
                    context={this.props.context}
                />
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        signinResponse,
        checkoutSessionInitResponse,
        cartDetails,
        orderItems,
        analyticsClickEvent,
        showGlobalLoader,
        serviceErrors,
        context,
        session,
        oosDetails,
        irisPromotionalBannerData,
    } = state;
    const featureFlags = get(state, 'context.featureFlags');
    const deviceType = get(state, 'context.deviceType');
    return {
        signinResponse,
        checkoutSessionInitResponse,
        cartDetails,
        orderItems,
        analyticsClickEvent,
        showGlobalLoader,
        serviceErrors,
        context,
        deviceType,
        featureFlags,
        isSessionTimedOut: session.isSessionTimedOut,
        enableKeepMeLoggedIn: get(state, 'context.featureFlags.enableKeepMeLoggedIn', false),
        oosDetails,
        irisPromotionalBannerDataContent: irisPromotionalBannerData?.content,
        irisRewardCustomerThreshold: irisPromotionalBannerData?.shippingThresholds?.rewardCustomer,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getCartDetails,
            ...SigninAction,
            ...splunkLogsActions,
            ...analyticsAction,
            ...siteAnalyticsAction,
            ...ServiceErrorMessageAction,
            ...PromotionalBannerActions,
        },
        dispatch
    ),
});

export default withBoundaryError(connect(mapStateToProps, mapDispatchToProps)(SignInPage), section);
